/**
 * Creates a array of slugs from a path (string)
 * @param path
 * @returns array of slugs (string)
 */
export function pathToSlugs(path: string): string[] {
  const cleanPath = path.replace(/\?.+/, "");
  if (cleanPath === "/" || cleanPath === "") {
    return ["start"];
  }
  return cleanPath.split("/").filter((x) => !!x);
}

/**
 * Extract last slug from params slug array
 * @param slugs
 * @returns last slug as string
 */
export const getSlug = (slugs: string[] | string, fallback: string): string =>
  Array.isArray(slugs) ? slugs[slugs.length - 1] : fallback;

/**
 * Get joined complete path from params slug array
 * @param slugs
 * @returns complete path as string
 */
export const getPath = (slugs: string[] | string): string =>
  Array.isArray(slugs) ? `/${slugs?.join("/")}` : "/";
